<button type="button" class="btn btn-contact icon-size-5 btn-circle btn-fixed" [ngClass]="{'active' : isContactOpen}"
        (click)="openContactWidget()"></button>


<div class="contact-toggle-box" [ngClass]="{'active' : isContactOpen}">
    <div class="backguard" (click)="openContactWidget()"></div>
    <div class="contact-box-content">
        <div class="contact-header">
            <h3>Kontakt</h3>
        </div>
        <div class="contact-inner">
            <h3 class="big mt-0 font-bolder">
                Ihr Ansprechpartner
            </h3>
            <div *ngFor="let extendedContact of extendedContacts" class="contact-container">
                <div class="d-flex mb-15">
                    <div class="contact-thumbnail" *ngIf="extendedContact.contact?.imageUrl">
                        <img [src]="extendedContact.contact.imageUrl" alt="">
                    </div>
                    <div class="contact-info-column">
                        <div class="font-bold">{{ extendedContact.contact?.firstName + ' ' + extendedContact.contact?.lastName }}</div>
                        <div class="small">{{ extendedContact.contact?.department }}</div>

                        <div class="d-flex small mt-05">
                            <bd-fa name="envelope" class="mr-05"></bd-fa>
                            <span class="ellipsis-h">{{ extendedContact.contact?.email }}</span></div>
                        <div class="d-flex small">
                            <bd-fa name="phone" class="mr-05"></bd-fa>
                            {{ extendedContact.contact?.phone }}
                        </div>
                    </div>
                </div>
                <a class="btn btn-primary fw font-bold small" [href]="requestCallback( extendedContact )">Rückruf anfragen</a>
            </div>


        </div>
    </div>
</div>
